export function renderPieChart(container, config) {
  const d3 = window.d3;
  if (!d3 || !config.data || !config.data.series || !config.data.series.length)
    return;

  const seriesArray = config.data.series;
  const idx = parseInt(config.dataIndex) || 0;

  // For pie chart: each series represents a slice
  // Use the first value from each series
  const pieData = seriesArray.map((s) => ({
    label: s.name,
    value: s.values[idx] || 0,
  }));

  const margin = {
    top: config.title ? config.margin.top * 0.25 : config.margin.top * 0.1,
    right: config.margin.right * 0.1,
    bottom: config.margin.bottom * 0.1,
    left: config.margin.left * 0.1,
  };
  if (config.subtitle) margin.top += 10;
  const width = config.width;
  const height = config.height;
  const innerWidth = width - margin.left - margin.right;
  const innerHeight = height - margin.top - margin.bottom;
  const radius = Math.min(innerWidth, innerHeight) / 2 - 5;

  // Clear previous chart
  const containerSelection = d3.select(container);
  containerSelection.selectAll('*').remove();

  const svgRoot = containerSelection
    .append('svg')
    .attr('viewBox', [0, 0, width, height]);
  const svg = svgRoot
    .append('g')
    .attr(
      'transform',
      `translate(${width / 2}, ${margin.top + innerHeight / 2})`
    );

  const color = d3
    .scaleOrdinal(d3.schemeCategory10)
    .domain(pieData.map((d) => d.label));

  // Tooltip
  const tooltip = d3
    .select('body')
    .append('div')
    .style('position', 'absolute')
    .style('background', 'white')
    .style('border', '1px solid #ccc')
    .style('padding', '4px 8px')
    .style('border-radius', '4px')
    .style('pointer-events', 'none')
    .style('font-size', '12px')
    .style('display', 'none')
    .style('z-index', '9999');

  // Pie layout
  const pie = d3
    .pie()
    .sort(null)
    .value((d) => d.value);

  const dataReady = pie(pieData);

  const arc = d3.arc().innerRadius(0).outerRadius(radius);

  const total = d3.sum(pieData, (d) => d.value);

  // Draw slices
  svg
    .selectAll('path')
    .data(dataReady)
    .join('path')
    .attr('d', arc)
    .attr('fill', (d) => color(d.data.label))
    .attr('stroke', 'white')
    .attr('stroke-width', 1)
    .attr('pointer-events', 'visiblePainted');

  if (config.tooltip) {
    svg
      .selectAll('path')
      .data(dataReady)
      .on('mouseover', (event, d) => {
        const percentage = ((d.data.value / total) * 100).toFixed(1);
        tooltip.style('display', 'block').html(`${percentage}%`);
      })
      .on('mousemove', (event) =>
        tooltip
          .style('left', event.pageX + 10 + 'px')
          .style('top', event.pageY - 20 + 'px')
      )
      .on('mouseout', () => tooltip.style('display', 'none'));
  }

  // Labels
  if (config.labels) {
    const labelArc = d3
      .arc()
      .innerRadius(radius * 0.6)
      .outerRadius(radius * 0.6);

    svg
      .selectAll('text')
      .data(dataReady)
      .join('text')
      .attr('transform', (d) => `translate(${labelArc.centroid(d)})`)
      .attr('text-anchor', 'middle')
      .attr('alignment-baseline', 'middle')
      .style('font-size', '11px')
      .text((d) => d.data.label);
  }

  if (config.title) {
    svgRoot
      .append('text')
      .attr('x', width / 2)
      .attr('y', margin.top / 2)
      .attr('text-anchor', 'middle')
      .style('font-size', '16px')
      .text(config.title);
  }

  if (config.subtitle) {
    svgRoot
      .append('text')
      .attr('x', width / 2)
      .attr('y', margin.top / 2 + 15)
      .attr('text-anchor', 'middle')
      .style('font-size', '12px')
      .style('fill', '#666')
      .text(config.subtitle);
  }

  // Legend
  if (config.legend) {
    const legend = containerSelection
      .append('div')
      .style('display', 'flex')
      .style('justify-content', 'center')
      .style('flex-wrap', 'wrap')
      .style('margin-top', '4px');

    pieData.forEach((d) => {
      const item = legend
        .append('div')
        .style('margin', '0 10px')
        .style('font-size', '12px');
      item
        .append('span')
        .style('display', 'inline-block')
        .style('width', '12px')
        .style('height', '12px')
        .style('background-color', color(d.label))
        .style('margin-right', '5px');
      item.append('span').text(d.label);
    });
  }
}
